var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrap"},[(!_vm.isPopup())?_c('lnb'):_vm._e(),_c('div',{class:['flexible-content', _vm.heightMaxClass]},[_c('div',{class:_vm.isPopup() ? '' : 'app-content',attrs:{"id":"content","role":"main"}},[(!_vm.isPopup())?_c('Header'):_vm._e(),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }